<div class="out"  kzLib (click)="clicked()">
  <img [ngClass]="{close : !bClosed}" src="assets/images/open.svg">
</div>